import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { ProfileSelectors } from '../../Redux/modules/profile/selectors';
import { AppSelectors } from '../../Redux/modules/app/selectors';
import ApiService from '../../Services/ApiService';
import styles from './Tabs.module.less';

const Tabs = (props) => {
  const isActive = ({ location: { pathname: currPath } }, toCheck) => {
    return currPath.includes(toCheck);
  };
  const getClass = (tab, i) => {
    let style = styles.tabLink;
    if (isActive(props, `/${tab.link}`)) {
      style = [style, styles.blue].join(' ');
    }
    if (i > 0) {
      style = [style, styles.secondTab].join(' ');
    }
    return style;
  };
  const apiContext = props.hasApiContext ? '/api' : '';
  return (
    <div>
      <div className={styles.tabContainer}>
        {props.tabs.map((tab, i) => {
          return (
            <div className={styles.tab} key={tab.title}>
              <Link to={`${apiContext}${ApiService.generateLink(tab.link)}`} className={getClass(tab, i)}>
                {tab.title}
              </Link>
            </div>
          );
        })}
      </div>
      <div className={styles.sectionSeparator} />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    profileDetails: ProfileSelectors.profileDetailsSelector(state),
    hasApiContext: AppSelectors.hasApiContextSelector(state),
  };
};

const mapDispatchToProps = {};

Tabs.propTypes = {
  tabs: PropTypes.array,
  hasApiContext: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Tabs));
